export const coverageEventQueryKeys = {
  all: ['coverage_events'],
  list: (warehouseId, params) => ['coverage_events', 'list', String(warehouseId), params],
  // Keyed by params too: the detail table pages and filters by state server-side.
  detail: (id, params) => ['coverage_events', 'detail', Number(id), params],
  // Matches every detail() key for a given id regardless of params — used to invalidate
  // the rows query after a mutation (close/cancel/add locations) without knowing the
  // caller's current page or state filter.
  detailAny: id => ['coverage_events', 'detail', Number(id)],
  drift: id => ['coverage_events', 'drift', Number(id)],
  differences: id => ['coverage_events', 'differences', Number(id)],
  openTotal: warehouseId => ['coverage_events', 'open_total', String(warehouseId)],
  // Keyed by params too: the reconciliation table pages server-side (and the endpoint can
  // filter by kind/outcome, not surfaced yet), same reasoning as detail() above.
  reconciliation: (id, params) => ['coverage_events', 'reconciliation', Number(id), params],
  // Matches every reconciliation() key for a given id regardless of params — used to
  // invalidate/refetch after execute without knowing the caller's current page or filters.
  reconciliationAny: id => ['coverage_events', 'reconciliation', Number(id)],
}
